import classApi from '@/api/industryClass'

export const industryClassSelMixin = {
  data () {
    return {
      canIndustryList: [],
      canSubIndustryList: [],
      allSubList: [],
      queryParams: {
        industryCategoryType: undefined, // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））	query	true	integer(int32)
        industryCategoryName: undefined, //	行业名称	query	false
        parentId: undefined //	父类ID	query	false	integer(int64)
      }
    }
  },

  methods: {
    getIndustryList () {
      this.queryParams.industryCategoryType = 1
      this.queryParams.parentId = undefined
      classApi.industryCategoryList(this.queryParams).then((res) => {
        if (res.code === 200) {
          this.canIndustryList = res.data
        }
      })
    },
    getSubIndustryList (pIds) {
      if (!(pIds && pIds.length > 0)) {
        this.form.industrySubclassJsonId = []
        this.canSubIndustryList = []
        return
      }
      this.queryParams.industryCategoryType = 2
      this.queryParams.parentId = undefined
      classApi.industryCategoryList(this.queryParams).then((res) => {
        if (res.code === 200) {
          const subList = res.data
          this.allSubList = JSON.parse(JSON.stringify(subList))
          if (pIds && pIds.length > 0) {
            this.canSubIndustryList = subList.filter((item) => {
              return pIds.indexOf(item.parentId) > -1
            })
          } else {
            this.canSubIndustryList = subList
          }
          const subIds = this.form.industrySubclassJsonId
          if (subIds && subIds.length > 0) {
            const selSubList = this.allSubList.filter((sub) => {
              return subIds.indexOf(sub.id) > -1
            })
            const curSelSubList = selSubList.filter((item) => {
              return pIds.indexOf(item.parentId) > -1
            })
            const selSubIdArr = []
            for (const cur of curSelSubList) {
              selSubIdArr.push(cur.id)
            }
            this.form.industrySubclassJsonId = selSubIdArr
          }
        }
      })
    }
  },
  created () {
    this.getIndustryList()
  }

}
